import React, { useState } from 'react'
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap'
import { formatNumber, formatPercent, reasonRows, titleRows } from '../../../utilities/dashboard'
import ChartCard, { DataTable } from './ChartCard'
import RankingChart from './RankingChart'
import useChartColors from './useChartColors'

// Principais motivos pelo título do prontuário: os grupos de palavras e, no modo Títulos, os 10 títulos exatos mais comuns
// e os que não caíram em nenhum grupo (para melhorar o dicionário). A base é quem tem evolução: o título está no prontuário
const ReasonsChart = ({ block, scopeLabel }) => {
  const { chart: colors } = useChartColors()
  const [mode, setMode] = useState('GROUPS')
  const reasons = block.data?.reasons
  const base = reasons?.total_pacientes_with_record ?? 0
  const groups = mode === 'GROUPS'
  const rows = groups ? reasonRows(reasons?.groups) : titleRows(reasons?.titles, base)
  const unclassified = titleRows(reasons?.unclassified_titles, base)

  const tooltipFor = (row) => ({
    title: row.label,
    rows: [
      { color: row.muted ? colors.others : colors.primary, value: formatNumber(row.value), label: `pacientes (${formatPercent(row.percent)} dos que têm evolução)` },
      { value: formatNumber(row.atendimentos), label: 'evoluções' },
    ],
  })

  // A contagem só com dados na tela: carregando ou com erro, fica só a regra (o erro nunca vira 0)
  const pacientesText = (reasons && !block.error) ? `os ${formatNumber(base)} pacientes` : 'os pacientes'
  const subtitle = groups
    ? `${scopeLabel} · % sobre ${pacientesText} com evolução no período · um prontuário pode entrar em mais de um grupo (a soma passa de 100%)`
    : `${scopeLabel} · os 10 títulos mais comuns, sem acento e em maiúsculas · % sobre ${pacientesText} com evolução`

  return (
    <ChartCard
      title='Principais motivos (título do prontuário)'
      info='prontuarios_reasons'
      subtitle={subtitle}
      tools={
        <ToggleButtonGroup type='radio' name='dashboard-reasons-mode' size='sm' value={mode} onChange={setMode}>
          <ToggleButton id='dashboard-reasons-groups' value='GROUPS' variant='outline-secondary'>Grupos</ToggleButton>
          <ToggleButton id='dashboard-reasons-titles' value='TITLES' variant='outline-secondary'>Títulos</ToggleButton>
        </ToggleButtonGroup>
      }
      skeleton={block.loading && !block.data}
      error={block.error}
      onRetry={block.reload}
      stale={block.loading && Boolean(block.data)}
      empty={!rows.length}
      height={300}
      renderTable={() => (
        <DataTable
          head={[groups ? 'Grupo' : 'Título', 'Pacientes', '%', 'Evoluções']}
          rows={rows.map((row) => [row.label, formatNumber(row.value), formatPercent(row.percent), formatNumber(row.atendimentos)])}
        />
      )}
      footer={(!groups && unclassified.length) ?
        <p className='dashboard-card-note'>
          <strong>Sem grupo:</strong> {unclassified.map((row) => `${row.label} (${formatNumber(row.value)})`).join(' · ')}
        </p>
        : null}
    >
      <RankingChart rows={rows} tooltipFor={tooltipFor} labelWidth={groups ? 140 : 190} />
    </ChartCard>
  )
}

export default ReasonsChart
